// PaymentHelper.js
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51KRWKsJjuv6C7hDrUPr9fXke5htreejAkJS3GL3818AI3NjNiGKl0zrEo2GDVt3pN0RMAtwnTIQCGohITPBBEegz006EAb3PP1';
